<ws-modal-wrapper [headerLabel]="headerLabel"
                  (cancel)="cancel()"
                  [loading]="isLoading && !gridData.rows"
                  [hideFooter]="true">
    <div class="assessment-taxes-details">
        @if (isLoading && gridData.rows) {
            <i class="fa fa-spinner fa-pulse fa-5x" style="position: absolute; top: 20%; left: 45%; z-index: 2;"
            ></i>
        }
        <table class="table table-condensed table-striped table-bordered" [class.table-loading]="isLoading">
            <thead>
                <tr class="active">
                    @for (header of gridData.headers; track header; let i = $index) {
                        <th
                            [class.text-center]="i > 0">{{ header }}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (row of gridData.rows; track row) {
                    <tr class="text-end" [class.is-total]="row.isTotal">
                        <td class="text-start">{{ row.label }}</td>
                        @for (field of row.fields; track field) {
                            <td [class.estimated]="field.isEstimated"
                                [class.under-appeal]="field.isUnderAppeal"
                                [class.text-center]="field.type === dataTypes.date">{{ field.displayValue }}
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
        @if(gridData.multipleTaxableValuesFootNote) {
            <div class="multiple-taxable-values-message">{{gridData.multipleTaxableValuesFootNote}}</div>
        }
        <div class="card panel-flat-color secondary-panel small-panel">
            <div class="panel-flat-header small-header">
                <h3>Criteria</h3>
                <div class="float-end header-button-container" style="margin-top:-3px;">
                    @if (!savingSettings) {
                        <button type="button" class="ace-btn btn-text has-icon btn-primary"
                                (click)="saveSettings()">
                            <i class="fa fa-save"></i>
                        </button>
                    }
                    @if (savingSettings) {
                        <button type="button" class="ace-btn btn-text has-icon btn-primary"
                                disabled>
                            <ws-ace-loader [inline]="true"></ws-ace-loader>
                        </button>
                    }
                    <button type="button" class="ace-btn btn-text has-icon btn-primary" (click)="loadGrid()">
                        <i class="fa fa-refresh"></i>
                    </button>
                </div>
            </div>
            <div class="card-body">
                @if (criteria) {
                    <div class="row">
                        <div class="col-lg-6">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <label>Tax Years:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.fromYear">
                                                @for (year of getSelectableYears(true); track year) {
                                                    <option
                                                        [ngValue]="year">{{ year }}
                                                    </option>
                                                }
                                            </select>
                                            to
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.toYear">
                                                @for (year of getSelectableYears(false); track year) {
                                                    <option
                                                        [ngValue]="year">{{ year }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Value Details:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.valueDetails">
                                                @for (value of valueDetailsOptions; track value; let i = $index) {
                                                    <option
                                                        [ngValue]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Break Out Tax Payment Details:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.breakOutTaxPaymentDetails">
                                                @for (value of breakOutTaxPaymentDetailsOptions; track value; let
                                                    i = $index) {
                                                    <option
                                                        [value]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Show % Change:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.showPercentChange">
                                                @for (value of showPercentChangeOptions; track value; let i = $index) {
                                                    <option
                                                        [value]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" [(ngModel)]="criteria.showLienDate"> Show Lien Date
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <table>
                                <tbody>
                                    <tr>
                                        <td>
                                            <label>Include Assessed Value Info:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.includeAssessedValueInfo">
                                                @for (value of includeAssessedValueInfoOptions; track value; let
                                                    i = $index) {
                                                    <option
                                                        [value]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Include Target Value:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.includeTargetValue">
                                                @for (value of includeTargetValueOptions; track value; let i = $index) {
                                                    <option
                                                        [value]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Include Valuation Metrics:</label>
                                        </td>
                                        <td>
                                            <select class="form-select form-select-sm"
                                                    style="width: auto; display: inline-block;"
                                                    [(ngModel)]="criteria.includeValuationMetrics">
                                                @for (value of includeValuationMetricsOptions; track value; let
                                                    i = $index) {
                                                    <option
                                                        [value]="i">{{ value }}
                                                    </option>
                                                }
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" [(ngModel)]="criteria.includePPPropertyType"> Include PP
                                    Property Type
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" [(ngModel)]="criteria.includePaymentDueDates"> Include
                                    Payment Due Dates
                                </label>
                            </div>
                            <div class="checkbox">
                                <label>
                                    <input type="checkbox" [(ngModel)]="criteria.includeAlternateAssessments">
                                    Include Alternate Assessments
                                </label>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </div>
</ws-modal-wrapper>
